import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab as MUITab } from '@material-ui/core'
import { getClassName, THEMES } from '../../utils'

import './sectionTab.component.scss'

/**
 * Section Tab Component
 * @param props
 */
class SectionTab extends Component {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { className, theme, activeTab, tabs, onChange } = this.props

    const baseClassName = getClassName('section-tab', [
      { condition: theme, trueClassName: `section-tab--${theme}` },
      { condition: className, trueClassName: className }
    ])

    return (
      <Tabs
        className={baseClassName}
        classes={{
          indicator: 'section-tab_indicator'
        }}
        value={activeTab} tabs={tabs} onChange={onChange}>
        {(tabs || []).map((tab, index) => {
          const tabClassName = getClassName('section-tab_item', [
            { condition: tab.value === activeTab, trueClassName: 'section-tab_item--active' }
          ])

          return (
            <MUITab
              key={`tab-${index}`}
              className={tabClassName}
              theme={theme}
              value={tab.value}
              label={tab.label}
              disableRipple />
          )
        })}
      </Tabs>
    )
  }
}

SectionTab.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf([THEMES.RAIN, THEMES.SLATE]),
  active: PropTypes.number,
  tabs: PropTypes.array.isRequired,
  onChange: PropTypes.func
}

SectionTab.defaultProps = {
  theme: THEMES.RAIN
}

export default SectionTab
